import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { Tooltip } from "@progress/kendo-react-tooltip";
import * as React from "react";
import ProviderLogo from "@/components/ProviderLogo";
import { getIcon } from "@/configs/services";
import TitleFilter from "@/helpers/title_filter";
// Inline (?react) so the SVG — which already paints with `currentColor` — is
// part of the DOM and inherits the control's theme-adaptive text colour. Loaded
// as an <img> it rendered `currentColor` as the initial black, so it vanished
// in dark mode.
import DataSourcesIcon from "@/icons/data_sources.svg?react";
import { ATTRIBUTE_SOURCE_CONNECTION_DATA } from "@/pages/Integrations/data";
import { getIcon as attributeSourceConnectionGetIcon } from "@/pages/UserAttributes/SourceConfigurations/getIcon";
import { IAccount } from "@/types/api";

const DataSourceRenderItem = (
  li: React.ReactElement<HTMLLIElement>,
  itemProps: ListItemProps,
) => {
  const dataItem: IAccount = itemProps.dataItem;
  const title = dataItem.name;
  const props = { ...li.props };

  const itemChildren = (
    <>
      {dataItem.name?.toLowerCase() === "all" ? (
        <DataSourcesIcon
          width={18}
          height={18}
          style={{
            marginRight: 5,
            verticalAlign: "sub",
          }}
        />
      ) : (
        getImage(dataItem)
      )}
      <span
        title={title}
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          display: "block",
          whiteSpace: "nowrap",
        }}
        className="longTitleOnly"
      >
        {title}
      </span>
    </>
  );

  return (
    <Tooltip anchorElement="target" position="top" filter={TitleFilter}>
      {React.cloneElement(li, props, itemChildren)}
    </Tooltip>
  );
};

type DataSourceItem = {
  sourceType?: string;
  type?: string;
  name?: string;
};

export const getImage = (dataItem: DataSourceItem) => {
  const imgSrc =
    dataItem?.sourceType === ATTRIBUTE_SOURCE_CONNECTION_DATA.id
      ? attributeSourceConnectionGetIcon(dataItem.type!)
      : getIcon(dataItem.type, 3);

  return imgSrc ? (
    <ProviderLogo src={imgSrc} className="tlx-provider-logo--spaced" />
  ) : null;
};

export const genericGetImage = (type: string) => {
  if (
    type === "accountId" ||
    type === "dataSourceTypes" ||
    type === "accountIds"
  ) {
    return (dataItem: DataSourceItem) => getImage(dataItem);
  }
  return undefined;
};

export const genericRenderItem = (type: string) => {
  if (type === "accountId") {
    return (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) =>
      DataSourceRenderItem(li, itemProps);
  }
  return undefined;
};

export default DataSourceRenderItem;
